module.exports = __webpack_public_path__ + "img/setup-min.73cf9256.jpg";